import { Box, Button, ButtonsGroup } from "@/components/atoms";
import { FC, memo, useCallback, useEffect, useRef, useState } from "react";
import { AddPostcodeProps } from "./AddPostcode.interface";
import { DESKTOP_SPACING } from "@/theme";
import { Modal } from "#/molecules";
import Select from 'react-select'

const AddPostCode: FC<AddPostcodeProps> = ({
  onAddPostcode,
  onClose
}) => {
    const [img, setImg] = useState('https://upload.wikimedia.org/wikipedia/commons/f/fe/British_postcode_areas_map.svg');
    const [mapData, setMapData] = useState(null);
    const [keys, setKeys] = useState<string[]>([]);
    const [options, setOptions] = useState<{label: string, value: string}[]>([]);
    const [areaOptions, setAreaOptions] = useState<{label: string, value: string}[]>([]);
    const [called, setCalled] = useState(false);

    const postcode = useRef('');
    const postcodeArea =  useRef('');

    useEffect(() => {
        if (called)
            return; 
        let mapDataLocal;

        fetch('/postcodeRegions.json')
            .then((res) => res.json())
            .then((data) => { 
                mapDataLocal = data; 
                const keysLocal = Object.keys(mapDataLocal);
                setKeys(keysLocal);
        
                const optionsLocal = keysLocal.map((key) => ({  label: key, value: key }));
                setOptions(optionsLocal);
                
                setMapData(mapDataLocal);
                setCalled(true);
            });

        
    }, [mapData])

    const handlePostcodeChange = useCallback((val:string) => {
        postcode.current = val;

        if (mapData)
        {
            if (keys.some(k => k === val))
            {
                const currentMap = mapData[val];
                setAreaOptions((currentMap["regions"] as string[]).map((key) => ({  label: key, value: key })));
                setImg(currentMap["links"][0])
            }
        }
    }, [mapData]);

    return (
        <Modal onClose={onClose} title="Add Postcode Area" width="600px" maxHeight="92%" top="5%">
            { mapData && (<>
            <Box margin="10px 0px">
                <Select options={options} onChange={(e) => { handlePostcodeChange(e.value);  } }  />
            </Box>
            <Box margin="10px 0px">
                <Select options={areaOptions} onChange={(e) => { postcodeArea.current = e.value;  } }  />
            </Box>
            <img src={img} style={{ maxHeight: '60svh', width: '80%'}}></img>
            <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
                <Button onClick={() => onAddPostcode(postcode.current, postcodeArea.current)}>Save</Button>
                <Button onClick={onClose}>Cancel</Button>
            </ButtonsGroup></>) }
        </Modal>
    );
}

export default memo(AddPostCode)